<template>
  <tr
    class="ds-text-base font-medium text-gray-900 border-0 border-t-0 border-b border-gray-200 border-solid cs-animation-ease-in"
  >
    <td class="px-4 py-4 md:py-3 text-center md:text-left w-3/6">
      <a
        v-if="hasVOD"
        :class="eventLinkClasses"
        @click="openEB(event)"
      >{{event.name}}</a>
      <a
        v-else-if="event.website"
        :class="eventLinkClasses"
        :href="event.website"
        target="_blank"
      >{{event.name}}</a>
      <p
        v-else
        class="mb-3 font-bold text-center md:text-left md:mb-0 md:font-normal"
      >{{event.name}}</p>
      <p class="mb-2 text-center md:text-left md:hidden">
        {{event.locationName}}
        <span v-if="event.locationCity && event.locationName">,</span>
        {{event.locationCity}}
      </p>
      <p class="text-center md:text-left md:hidden">{{getFormattedDate(event.startDate)}}<span v-if="(isValidDate(event.endDate) && !datesAreOnSameDay(event.startDate, event.endDate))"> - {{getFormattedDate(event.endDate)}}</span></p>

      <!-- Event Beacon -->
      <EBModal size="modal-xs" v-if="isEB" class="mr-3 md:hidden mt-3 -mr-1" showModal="false" />
    </td>
    <td class="hidden px-4 py-3 md:table-cell w-1/6">{{getFormattedDate(event.startDate)}}<span v-if="(isValidDate(event.endDate) && !datesAreOnSameDay(event.startDate, event.endDate))"> - {{getFormattedDate(event.endDate)}}</span></td>
    <td class="hidden px-4 py-3 md:table-cell w-2/6" colspan="2">
      {{event.locationName}}
      <span v-if="event.locationCity && event.locationName">,</span>
      {{event.locationCity}}
    </td>
    <td class="hidden px-4 py-3 md:table-cell">
      <!-- Event Beacon -->
      <EBModal size="modal-xs" v-if="isEB && !isCollegeCoach" class="mr-3" showModal="false" />
      <div v-else-if="isEB && hasVOD">
        <div
            class="cursor-pointer select-none inline-block pr-3 bg-indigo-300 border border-indigo-300 border-solid rounded-full order-first md:order-last"
            @click="redirectToEventBeacon(event)"
        >
          <div class="flex flex-row items-center">
            <i
                class="flex flex-col items-center justify-center w-6 h-6 p-0 mr-1 text-indigo-300 bg-white rounded-full sr-2 sr-v2-eventbeacon-mark ds-text-base"
            ></i>
            <p class="m-0 font-medium text-white whitespace-no-wrap ds-text-xs">EventBeacon Event</p>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import EBModal from "@/components/ProfileEBExplanationModal";
import track from "@/utils/segment";
import api from "@/services/api";
import moment from "moment";

export default {
  props: {
    event: Object,
    user: Object
  },
  components: {
    EBModal
  },
  data() {
    return {
      eventLinkClasses:
        "mb-3 font-bold text-center md:text-left md:mb-0 md:font-normal text-blue-300 hover:text-blue-400 cursor-pointer",
      eventBeaconClasses:
      "m-0 font-medium text-white whitespace-no-wrap ds-text-xs"
    };
  },
  computed: {
    ...mapGetters("athleteProfile", {
      userSport: "sport"
    }),
    ...mapState({
      studentId: state => state.athleteProfile.user.id,
    }),
    ...mapGetters("userData", ["isCollegeCoach", "relevantGender", "sport"]),
    isEB() {
      return this.event.isEventBeacon || this.event.vodAvailable;
    },

    hasVOD() {
      if (!this.event.vodAvailable || !this.event.gender) return false;
      let now = moment();
      let vodAvailable = moment(this.event.vodAvailable);
      return (
          this.event.active &&
          now.isAfter(vodAvailable) &&
          this.isCollegeCoach &&
          this.relevantGender === this.event.gender &&
          this.userSport.name === this.sport.name
      );
    }
  },
  methods: {
    openEB(event) {
      track('clicked_view_event_on_ebod', {
        action: 'click',
        athlete_viewed: window.location.href,
        cta_location: 'event_section',
        cta_page: 'athlete_profile',
        email: api.clientData('site_email'),
        event_clicked_id: event.id,
        event_clicked_name: event.name,
        site_access_id: api.clientData('site_access_id'),
      });
      window.open(`/eb_on_demand/events/${event.id}/${event.urlSlug}/?studentId=${this.studentId}`, '_blank');
      return;
    },
    getFormattedDate(dateString) {
      if (!dateString) {
        return null;
      }
      let date = dateString.split("T")[0];
      let [year, month, day] = date.split("-");
      return month + "/" + day + "/" + year.slice(-2);
    },
    datesAreOnSameDay(first, second) {
      first = new Date(first);
      second = new Date(second);
      return first.getFullYear() === second.getFullYear() &&
          first.getMonth() === second.getMonth() &&
          first.getDate() === second.getDate();
    },
    isValidDate(d) {
      d = new Date(d);
      return d instanceof Date && !isNaN(d);
    },
    redirectToEventBeacon(event) {
      track('clicked_view_event_on_ebod', {
        action: 'click',
        athlete_viewed: window.location.href,
        cta_location: 'event_section',
        cta_page: 'athlete_profile',
        email: api.clientData('site_email'),
        event_clicked_id: event.id,
        event_clicked_name: event.name,
        site_access_id: api.clientData('site_access_id'),
      });
      window.open("/eb_on_demand/events/" + event.id + "/" + event.urlSlug + '?studentId=' + this.studentId, "_blank");

    }
  }
};
</script>

<style>
</style>